import React from "react";

export default function MySQL_UPPER() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_UPPER</h1>
      <p>This is the MySQL_UPPER component generated from the SQL JSON.</p>
    </div>
  );
}
